import { Provider } from 'cerebral'
import axios from 'axios'
import prependSlashMaybe from 'utils/prependSlashMaybe'

const url = process.env.PUBLIC_URL
  ? `${prependSlashMaybe(process.env.PUBLIC_URL)}/graphql`
  : '/graphql'

export default function(token) {
  const call = (query, token) => {
    return new Promise((resolve, reject) => {
      axios(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          token: token
        },
        data: JSON.stringify(query)
      })
        .then(response => {
          return response.data
        })
        .then(json => {
          resolve({ ...json.data })
        })
        .catch(e => {
          if (e.response.status === 401) {
            if (token) {
              return (window.location.href = 'https://web2print.billes.se/')
            }
            return (window.location.href = window.location.origin)
          }

          reject(e)
        })
    })
  }

  return Provider({
    async query(query) {
      const res = await call({ query }, token)
      return res
    },
    async mutate(query) {
      const res = await call({ query: `mutation${query}` }, token)
      return res
    }
  })
}



// WEBPACK FOOTER //
// ./src/providers/GraphQLProvider.js